/** Mirrors the backend's VAULT_SUB_MODULES (apps/api/src/user/constant.ts). */
export const VAULT_SUB_MODULES = {
  KNOWLEDGE_BASE: 'KNOWLEDGE-BASE',
};
